// import React from 'react';
// import NextImage from '@/features/Image';
// import parse from 'html-react-parser';
// import { parse as parseUrl } from 'url';
// import Link from 'next/link';

// type Props = {
//   title: string;
//   description: string;
//   banner: string;
//   banner_web: string;
//   btn_name: string;
//   route: string;
//   is_active: string;
// };

// const KireiTube = ({ data }: { data: Props }) => {
//   const linkPath = data?.route
//     ? parseUrl(data.route).pathname
//     : '/personal-recommendation/skincare-recommendation';

//   return (
//     <section className="newsletter padding-top padding-bottom section-bg">
//       <div className="container">
//         <div className="row kireitube">
//           <div className="col-md-6 content">
//             <h2>{data?.title}</h2>
//             <p dangerouslySetInnerHTML={{ __html: data?.description }}></p>
//             {/* {data?.description && parse(data?.description)} */}
//             <Link href={`${linkPath}`} className="trk-btn trk-btn--primary">
//               {data?.btn_name}
//             </Link>
//           </div>
//           <div className="col-md-6">
//             <div className="kireitube-image mx-auto mt-4">
//               <NextImage
//                 width={289}
//                 height={401}
//                 src={data?.banner_web}
//                 alt="Discover Beauty with Kirei Tube"
//                 className="newsletter-image"
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default KireiTube;

// src/features/kirei-tube/components/KireiTube.tsx

// This is a pure Server Component. It needs no 'use client' directive.
'use client';
import Link from 'next/link';
import Image from 'next/image'; // Use the original next/image
import { fetcher } from '@/lib/fetcher';
import NextImage from '@/features/Image';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { KireiTubeSkeleton } from './KireiTubeSkeleton';

// Define the shape of the data for type safety
type KireiTubeData = {
  title: string;
  description: string;
  banner_web: string;
  btn_name: string;
  route: string;
};

// The component is now ASYNC and takes NO PROPS
const KireiTube = () => {
  // ✅ DATA IS FETCHED HERE, INSIDE THE COMPONENT
  const { data: homeThings, isLoading } = useFetcherCSR(
    `/api/v2/home-things?for=desktop`
  );
  // const homeThings = await fetcher('/api/v2/home-things?for=desktop');
  const data = homeThings?.homepage_settings?.kireitube as
    | KireiTubeData
    | undefined;

  // If there's no data, don't render the section
  if (!data) {
    return null;
  }
  if (isLoading) return <KireiTubeSkeleton />;

  // Helper function to safely parse a URL path
  const getPathname = (
    route: string | undefined,
    defaultPath: string
  ): string => {
    if (!route) return defaultPath;
    try {
      return new URL(route).pathname;
    } catch (e) {
      if (route.startsWith('/')) return route;
    }
    return defaultPath;
  };

  const linkPath = getPathname(data.route, '/kirei-tube');

  return (
    <section className="newsletter padding-top padding-bottom section-bg">
      <div className="container">
        <div className="row kireitube">
          <div className="col-md-6 content">
            <h2>{data?.title}</h2>
            <p dangerouslySetInnerHTML={{ __html: data?.description }}></p>
            {/* {data?.description && parse(data?.description)} */}
            <Link href={`${linkPath}`} className="trk-btn trk-btn--primary">
              {data?.btn_name}
            </Link>
          </div>
          <div className="col-md-6">
            <div className="kireitube-image mx-auto mt-4">
              <NextImage
                width={289}
                height={401}
                src={data?.banner_web}
                alt="Discover Beauty with Kirei Tube"
                className="newsletter-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KireiTube;
